export default __webpack_public_path__ + "static/media/dhu2jpg.4ce12830.jpg";